export const downloadFile = (url: string, blob: Blob, fileOutputName?: string) => {
  // create file link in browser's memory
  const href = URL.createObjectURL(blob);
  // create "a" HTML element with href to file & click
  const link = document.createElement("a");
  const fileNameInUrl = url?.split("/").pop()?.split("?")[0];
  link.href = href;
  link.setAttribute("download", fileOutputName || fileNameInUrl || "download"); // or any other extension
  document.body.appendChild(link);
  link.click();

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};
